import { useContext, useState } from 'react';
import React, { useRef } from 'react';
import { Alert, Button, Card, Col, Container, Row } from 'react-bootstrap';
import '../../../assets/css/Drivers/DriverSetting/DriverQRcode.css';
import DriverSettingsMasterLayout from '../../../layouts/Drivers/DriverSettingsMasterLayout';
import AppContext from '../../../context/AppContext';


const DriverQRCode = () => {
    const qrRef = useRef(null);
    const { baseUrlforfile } = useContext(AppContext);
    const [driverData] = useState(JSON.parse(localStorage.getItem("tddriver")));

    const [showCopied, setShowCopied] = useState(false);

    const handleDownloadQR = () => {
        // In real app, this would download the QR code image
        const link = document.createElement('a');
        link.href = driverData.qrcode;
        link.download = `Trustidrive_QR_${driverData.driverId}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleShareQR = () => {
        if (navigator.share) {
            navigator.share({
                title: 'Trustidrive - Transfer Coins',
                text: `Scan this QR code to transfer coins to ${driverData.name}`,
                url: driverData.qrCodeUrl,
            }).catch((error) => console.log('Error sharing:', error));
        } else {
            alert('Sharing not supported on this device');
        }
    };

    const handleCopyDriverId = () => {
        navigator.clipboard.writeText(driverData.driverId);
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
    };

    const handlePrint = () => {
        window.print();
    };

    return (
        <DriverSettingsMasterLayout screenName={"My QR code"} centered={true}>
            <div className="driver-qrcode-page">
                <Container className="py-4">

                    {/* Success Alert */}
                    {showCopied && (
                        <Alert variant="success" className="mb-4 text-center">
                            Driver ID copied to clipboard! ✓
                        </Alert>
                    )}

                    {/* Main QR Code Card */}
                    <Row>
                        <Col lg={8} className="mx-auto">
                            <Card className="qr-code-card">
                                <Card.Body className="text-center">
                                    {/* Header Info */}
                                    <div className="qr-header">
                                        <div className="qr-icon-wrapper">
                                            <div className="qr-icon">💰</div>
                                        </div>
                                        <h4 className="mt-2 mb-0">Receive Coins from Customers</h4>
                                        <p className="text-muted mb-0 small-text">
                                            Show this QR code to customers for coin transfers
                                        </p>
                                    </div>

                                    {/* QR Code Display */}
                                    <div className="qr-code-wrapper" ref={qrRef}>
                                        <div className="qr-code-container">
                                            <img
                                                src={`${baseUrlforfile}/${driverData.qrcode}`}
                                                alt="Driver QR Code"
                                                className="qr-code-image"
                                            />
                                        </div>

                                        {/* Driver Info Below QR */}
                                        <div className="driver-info-badge">
                                            <h5 className="mb-1">{driverData.name}</h5>
                                            <div className="driver-id-section">
                                                <span className="driver-id-label">Driver ID:</span>
                                                <span className="driver-id-value">{driverData.driverId}</span>
                                                <button
                                                    className="copy-id-btn"
                                                    onClick={handleCopyDriverId}
                                                >
                                                    📋
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="action-buttons">
                                        <Button
                                            className="action-btn primary-btn"
                                            style={{ backgroundColor: '#1B9B82', border: 'none' }}
                                            onClick={handleDownloadQR}
                                        >
                                            📥 Download QR Code
                                        </Button>
                                        <Button
                                            className="action-btn secondary-btn"
                                            variant="outline-secondary"
                                            onClick={handleShareQR}
                                        >
                                            📤 Share QR Code
                                        </Button>
                                        <Button
                                            className="action-btn secondary-btn"
                                            variant="outline-secondary"
                                            onClick={handlePrint}
                                        >
                                            🖨️ Print QR Code
                                        </Button>
                                    </div>


                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </DriverSettingsMasterLayout>

    );
};

export default DriverQRCode;